import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { WebApiDto } from '../models/webapi/webapi-dto.model';

@Injectable({ providedIn: 'root' })
export class WebApiService {
  private _http = inject(HttpClient);

  public getWebApi(alias: string): Promise<WebApiDto> {
    if (environment.fixedWebAppApiUrl) {
      const webApiDto = new WebApiDto();
      webApiDto.url = environment.fixedWebAppApiUrl;
      webApiDto.cloudType = 'BauPlusCloud';

      return Promise.resolve(webApiDto);
    }

    if (environment.production) {
      return firstValueFrom(this._http.get<WebApiDto>(`${environment.apiUrl}/cloud/webapp/webapi?alias=${alias}`));
    }

    return firstValueFrom(
      this._http.get<WebApiDto>(`${environment.apiUrl}/cloud/webapp/webapi?alias=${alias}&develop=true`),
    );
  }
}
